import React, { createContext, useContext, useState } from 'react';

export const DIMENSION_COLORS: Record<string, string> = {
  "A": "#e879f9",
  "B": "#22d3ee",
  "C": "#22d3ee",
  "D": "#a3e635",
  "E": "#fb923c",
  "F": "#fb923c"
};

// 根据我们前面看到的 mocks，导出统一的类型结构。
// 这里使用任意类型以便灵活拓展，实际应用中可以指定严格接口
export interface EvalData {
  courseEvalData: any;
  teacherDetailData?: any;
  videoFilename?: string;
}

export interface EvalContextState {
  evalData: EvalData | null;
  setEvalData: React.Dispatch<React.SetStateAction<EvalData | null>>;
}

const EvalContext = createContext<EvalContextState | undefined>(undefined);

export function EvalProvider({ children }: { children: React.ReactNode }) {
  const [evalData, setEvalData] = useState<EvalData | null>(null);

  return (
    <EvalContext.Provider value={{ evalData, setEvalData }}>
      {children}
    </EvalContext.Provider>
  );
}

export function useEval() {
  const context = useContext(EvalContext);
  if (!context) {
    throw new Error('useEval must be used within an EvalProvider');
  }
  return context.evalData;
}

export function useEvalDispatch() {
  const context = useContext(EvalContext);
  if (!context) {
    throw new Error('useEvalDispatch must be used within an EvalProvider');
  }
  return context.setEvalData;
}
